// src/components/FooterDocs.js
function FooterDocs() {
  return (
    <footer className="bg-gray-100 dark:bg-gray-900 border-t border-gray-300 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-4 py-6 grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
        
        {/* Columna 1 */}
        <div>
          <h3 className="font-semibold text-gray-700 dark:text-gray-200 mb-2">Zamintech</h3>
          <p className="text-gray-600 dark:text-gray-400">
            Soluciones tecnológicas innovadoras para empresas y municipios.
          </p>
        </div>

        {/* Columna 2 */}
        <div>
          <h3 className="font-semibold text-gray-700 dark:text-gray-200 mb-2">Enlaces útiles</h3>
          <ul className="space-y-1">
            <li><a href="/" className="text-blue-600 dark:text-blue-400 hover:underline">Inicio</a></li>
            <li><a href="/servicios" className="text-blue-600 dark:text-blue-400 hover:underline">Servicios</a></li>
            <li><a href="/contacto" className="text-blue-600 dark:text-blue-400 hover:underline">Contacto</a></li>
            <li><a href="/documentacion" className="text-blue-600 dark:text-blue-400 hover:underline">Documentación</a></li>
          </ul>
        </div>

        {/* Columna 3 */}
        <div>
          <h3 className="font-semibold text-gray-700 dark:text-gray-200 mb-2">Recursos</h3>
          <ul className="space-y-1">
            <li><a href="https://github.com/turepo" target="_blank" rel="noopener noreferrer" className="text-blue-600 dark:text-blue-400 hover:underline">GitHub</a></li>
            <li><a href="https://www.zamintech.net" target="_blank" rel="noopener noreferrer" className="text-blue-600 dark:text-blue-400 hover:underline">Sitio oficial</a></li>
            <li><a href="mailto:estefangz@zamintech.net" className="text-blue-600 dark:text-blue-400 hover:underline">Correo</a></li>
          </ul>
        </div>

      </div>
      <div className="text-center text-gray-500 dark:text-gray-400 text-xs py-4 border-t border-gray-300 dark:border-gray-700">
        © {new Date().getFullYear()} Zamintech. Todos los derechos reservados.
      </div>
    </footer>
  );
}

export default FooterDocs;
